import {
    Box,
    Tooltip,
    Typography,
    Chip
} from '@mui/material';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WarningIcon from '@mui/icons-material/Warning';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddRoadIcon from '@mui/icons-material/AddRoad';

export default function TripStatusSummary({
    statusTrip,
    barColor,
    situacao,
    detaTrip,
    hrInicio,
    atendP,
    totalP,
    progressoPontos,
    kmsRodados,
    kmTotalRota,
    diferencaKm
}) {

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
            }}
        >
            {/* ========================= */}
            {/* SITUAÇÃO */}
            {/* ========================= */}

            {statusTrip === 0 &&
                <CalendarMonthIcon
                    color={barColor}
                    sx={{ fontSize: 22 }}
                />
            }

            {[1, 2, 3].includes(statusTrip) &&
                <WarningIcon
                    color={barColor}
                    sx={{ fontSize: 22 }}
                />
            }

            {statusTrip === 4 &&
                <ReportGmailerrorredIcon
                    color={barColor}
                    sx={{ fontSize: 22 }}
                />
            }

            <Typography
                variant="subtitle1"
                color={barColor}
            >
                <strong>
                    {situacao} {detaTrip}
                </strong>
            </Typography>

            {/* ========================= */}
            {/* ATENDIMENTO */}
            {/* ========================= */}

            {hrInicio &&
                <>
                    <b>|</b>

                    <CheckCircleIcon
                        color={barColor}
                        sx={{ fontSize: 22 }}
                    />

                    <Typography
                        variant="subtitle1"
                        color={barColor}
                    >
                        <strong>
                            Atendeu {atendP} de {totalP} pontos
                        </strong>

                        {' '}({progressoPontos}%)
                    </Typography>
                </>
            }

            {/* ========================= */}
            {/* QUILOMETRAGEM */}
            {/* ========================= */}

            <b>|</b>

            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.2
                }}
            >
                {/* ========================= */}
                {/* KM RODADOS */}
                {/* ========================= */}

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75
                    }}
                >
                    <Tooltip title="Quilômetros rodados">
                        <Box
                            sx={(theme) => ({
                                width: 28,
                                height: 28,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor:
                                    theme.palette.primary.main + '18'
                            })}
                        >
                            <AddRoadIcon
                                color={barColor}
                                sx={{
                                    fontSize: 18
                                }}
                            />
                        </Box>
                    </Tooltip>

                    <Typography
                        variant="subtitle1"
                        color="text.primary"
                    >
                        <strong>
                            {kmsRodados} km
                        </strong>
                    </Typography>
                </Box>

                {/* ========================= */}
                {/* KM TOTAL ROTA */}
                {/* ========================= */}

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75
                    }}
                >
                    <Tooltip title="Quilometragem prevista da rota">
                        <Box
                            sx={(theme) => ({
                                width: 28,
                                height: 28,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color:
                                    theme.palette.info.main,
                                backgroundColor:
                                    theme.palette.info.main + '18'
                            })}
                        >
                            <AddRoadIcon
                                sx={{
                                    fontSize: 18
                                }}
                            />
                        </Box>
                    </Tooltip>

                    <Typography
                        variant="subtitle1"
                        color="text.primary"
                    >
                        <strong>
                            {kmTotalRota} km
                        </strong>
                    </Typography>
                </Box>

                {/* ========================= */}
                {/* DIFERENÇA */}
                {/* ========================= */}

                {diferencaKm &&
                    <Chip
                        size="small"
                        label={
                            `${diferencaKm.tipo}${diferencaKm.km} km`
                        }
                        color="warning"
                    />
                }
            </Box>
        </Box>
    );
}